export const userAddressFormDefaultValues = {
  zip_code: '',
  type: '',
  street: '',
  number: '',
  complement: '',
  district: '',
  address_city: { value: '', label: '' }
}
